import type { Card } from '@braze/web-sdk';
import { getBrazeInstance } from '../client';
import { mountBrazeContentCardsUI } from '../ui/NotificationUIManager';

interface ExtendedCard extends Card {
    dismissed?: boolean;
}

export async function getContentCards(): Promise<void> {
    try {
        const braze = await getBrazeInstance();
        //Set up listener for updates, Only needed once
        braze.subscribeToContentCardsUpdates(() => {
            const cards: Card[] = braze.getCachedContentCards().cards;
            console.log('Content Cards updated:', cards);
            mountBrazeContentCardsUI(cards);
        });
        braze.showContentCards();
        braze.requestContentCardsRefresh();
    } catch (error) {
        console.error('[Braze] Error fetching content cards:', error);
    }
}

export async function hasUnseenContentCards(): Promise<boolean> {
    const braze = await getBrazeInstance();
    if (braze === null) {
        throw new Error('[Braze] SDK not initialized. Call initBraze() first.');
    }

    await braze.requestContentCardsRefresh();

    return new Promise((resolve) => {
        braze.subscribeToContentCardsUpdates(() => {
            const cards = braze.getCachedContentCards().cards as ExtendedCard[];

            const hasUnseen = cards.some(
                (card) => !card.viewed && !card.dismissed,
            );

            resolve(hasUnseen);
        });
    });
}
